<template>
    <div class="visual-box">
        <div class="visual-header">
            <el-image v-if="appInfo" :src="appInfo.logo.square"></el-image>
            <span v-if="appInfo">{{ appInfo.name }}}</span>

            <el-button type="primary" class="button-save" @click="saveAppVisualConfig()">保存</el-button>
            <el-button type="primary" class="button-export" @click="exportJSON()" plain>导出</el-button>
        </div>
        <div style="height:50px"></div>
        <div class="visual-content">
            <div class="decoreation-menu">
                <DecorationMenu />
            </div>
            <div class="decoreation-app">
                <DecorationApp :appObj="appObj" />
            </div>
            <div class="decoreation-prop">
                <DecorationProp />
            </div>
        </div>

    </div>
</template>

<script>
import DecorationMenu from './DecorationMenu.vue';
import DecorationApp from './DecorationApp.vue';
import DecorationProp from './DecorationProp.vue';

import { GetAppInfo, GetAppVisualConfig, SaveAppVisualConfig } from '@/request/api'
import { newApp } from '@/common/const';

export default {
    name: "Decoration",
    components: {
        DecorationMenu,
        DecorationApp,
        DecorationProp
    },
    data() {
        return {
            appInfo: null,
            appObj: null
        }
    },
    methods: {
        exportJSON() {
            const json = JSON.stringify(this.appObj)
            this.$message.success('已复制')
            const inputDom = document.createElement('input');
            inputDom.setAttribute('value', json);
            document.body.appendChild(inputDom);
            inputDom.select();
            document.execCommand('copy');
            document.body.removeChild(inputDom);
        },
        /**
         * 获取APP信息
         */
        getAppInfo() {
            const appID = this.$route.params.id
            GetAppInfo(appID).then(data => {
                console.log('成功', data)
            }).catch(error => {
                console.log('失败', error)
            })
        },

        /**
         * 获取可视化配置
         */
        getAppVisualConfig() {
            const appID = this.$route.params.id
            GetAppVisualConfig(appID).then(data => {
                console.log('获取配置成功', data)
                if (data.config) {
                    this.appObj = JSON.parse(JSON.stringify(data.config))
                    //兼容之前
                    if (!this.appObj.config) {
                        this.appObj.config = {
                            bottom_tab_style: 'icon',
                        }
                    }
                } else {
                    this.appObj = newApp()
                }
            })
                .catch(error => {
                    console.error(error)
                    this.$message.error('获取配置失败')
                    this.appObj = newApp()
                })
        },
        saveAppVisualConfig() {
            console.log('params', this.$route.params)
            const appID = this.$route.params.id
            const config = JSON.stringify(this.appObj)
            SaveAppVisualConfig(appID, config).then(data => {
                this.$message.success('保存配置成功')
                console.log('保存配置成功', data)
            })
                .catch(error => {
                    console.error(error)
                    this.$message.error('保存配置失败')
                })
        }
    },
    mounted() {
        // this.getAppInfo()
        this.getAppVisualConfig()
    }
}

</script>

<style scoped lang="less">
.visual-box {
    height: 100%;
}

.visual-header {
    height: 50px;
    background-color: #fff;
    position: fixed;
    top: 0px;
    right: 0px;
    left: 0px;
    z-index: 999;
    box-shadow: 0 2px 4px 0 var(--cb-color-shadow, rgba(0, 0, 0, 0.16));

    .button-save {
        position: absolute;
        right: 15px;
        height: 30px;
        top: 10px;
    }

    .button-export {
        position: absolute;
        right: 90px;
        height: 30px;
        top: 10px;
    }
}

.visual-content {
    display: flex;
    height: calc(100% - 50px);

    .decoreation-menu {
        flex: 2;
        overflow-y: overlay;
    }

    .decoreation-app {
        flex: 5;
        padding-top: 20px;
        background-color: #F5F5F5;
        position: relative;
    }

    .decoreation-app::-webkit-scrollbar {
        width: 0;
    }


    .decoreation-prop {
        flex: 3;
        overflow-y: auto;
    }

    .decoreation-prop::-webkit-scrollbar {
        width: 0;
    }
}
</style>